"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATH_ACTION = void 0;
exports.PATH_ACTION = 'filter';
const isPathAction = (action) => action === exports.PATH_ACTION;
exports.default = isPathAction;
